/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ValidationResult {
    getFixupPrototypeFunction() { return ValidationResult.fixupPrototype; }

    static newInstance(model: Partial<ValidationResult>): ValidationResult {
        let obj = Object.assign(new ValidationResult(), model);
        ValidationResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ValidationResult>): ValidationResult {
        if (!model) return null;
        return ValidationResult.newInstance(<ValidationResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ValidationResult) {
        if (!obj) return;

        models.ValidationResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ValidationResult): boolean {
        Object.setPrototypeOf(obj, ValidationResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    field: string;

    reason: string;

}
